import { Alert } from "@mui/material";

import { LoadingWrappedNode } from "components/LoadingWrappedNode/LoadingStateWrappedNode";
import { PaymentMethodRequiredWrapper } from "components/PaymentMethodRequiredWrapper";
import { useCarrierShipmentPageContext } from "hooks";
import { formatText } from "utils";

import { AgreementModal } from "../AgreementModal";
import { MultiShipmentSubmitQuoteFormAccessWrapper } from "../MultiShipmentSubmitQuoteFormAccessWrapper";
import { NoCapacityButtonContainer } from "../NoCapacityButton";
import { AddPaymentInformationLabel } from "../ShipmentOverviewExpanded/components/AddPaymentInformationLabel";
import { SubmitQuoteForm } from "../SubmitQuoteForm";

export function SubmitQuote() {
  const { shipment } = useCarrierShipmentPageContext();

  if (!shipment) {
    return <LoadingWrappedNode loading>{null}</LoadingWrappedNode>;
  }

  if (shipment.shipment_status === "CANCELLED") {
    return <Alert severity="warning">This shipment has been cancelled.</Alert>;
  }

  if (
    shipment.shipment_status === "EXPIRED" ||
    shipment.shipment_status === "PICKED_UP" ||
    shipment.shipment_status === "DELIVERED" ||
    shipment.shipment_status === "BOOKED" ||
    shipment.shipment_status === "BOOKING_CANCELLED"
  ) {
    return (
      <Alert severity="warning">
        This shipment is not bookable. Status:
        {` ${formatText(shipment.shipment_status)}.`}
      </Alert>
    );
  }

  let formComponent = (
    <SubmitQuoteForm
      shipment={shipment}
      secondaryAction={<NoCapacityButtonContainer />}
    />
  );
  if (shipment.info?.type === "MULTI_SHIPMENT_PROJECT") {
    formComponent = (
      <MultiShipmentSubmitQuoteFormAccessWrapper
        secondaryAction={<NoCapacityButtonContainer />}
      />
    );
  }

  return (
    <AgreementModal shipmentId={shipment.info.id}>
      <div>
        {!shipment.is_partner_shipment ? (
          <PaymentMethodRequiredWrapper
            enableWithSubscriptionPlan="CARRIER_PAY_PER_BOOKING"
            noPaymentMethodComponent={<AddPaymentInformationLabel />}
          >
            {formComponent}
          </PaymentMethodRequiredWrapper>
        ) : (
          <div>{formComponent}</div>
        )}
      </div>
    </AgreementModal>
  );
}
